/** Frontend model for one referred account in the partner detail, with parsed dates. */
export interface ReferralEntry {
  id: string;
  instructorId: string;
  firstName: string;
  lastName: string;
  email: string;
  bountyAmountMinorUnits: number;
  bountyCurrency: string;
  attributedAt: Date;
  convertedAt: Date | null;
  paidAt: Date | null;
}

export type ReferralEntryStatus = "attributed" | "converted" | "paid";

/** attributed → converted → paid, derived from the timestamps. */
export const referralEntryStatus = (entry: ReferralEntry): ReferralEntryStatus => {
  if (entry.paidAt) return "paid";
  if (entry.convertedAt) return "converted";
  return "attributed";
};
